// Sección de la barra lateral: título en mayúsculas con línea inferior y
// contenido compacto debajo.
export default function SidebarSection({ title, children }) {
  return (
    <section className="cv-side-section">
      <h3 className="cv-side-title">{title}</h3>
      {children}
    </section>
  );
}
